var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrokenBone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2037 9.25642C19.1538 9.88584 20.4463 9.78203 21.2834 8.94499C22.2389 7.98944 22.2389 6.44019 21.2834 5.48464C20.7174 4.91868 19.9432 4.68793 19.2074 4.7924C19.3118 4.05668 19.081 3.28256 18.5151 2.71666C17.5596 1.76111 16.0104 1.76111 15.0549 2.71666C14.2179 3.55365 14.1141 4.84617 14.7433 5.7962L12.1728 8.36681C12.3305 8.52461 12.4146 8.75209 12.3806 8.98994L12.1094 10.8884L13.0203 11.3439C13.2086 11.438 13.3474 11.6085 13.4015 11.812C13.4555 12.0155 13.4196 12.2324 13.3028 12.4076L12.2525 13.9831L12.8648 14.5955L18.2037 9.25642Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.94513 21.2833C7.9896 22.2389 6.44039 22.2389 5.48486 21.2833C4.91898 20.7174 4.68822 19.9433 4.7926 19.2076C4.05682 19.3121 3.2826 19.0813 2.71665 18.5154C1.76112 17.5598 1.76112 16.0106 2.71665 15.055C3.55365 14.218 4.84619 14.1142 5.7962 14.7435L10.789 9.75067L10.5813 11.2046C10.5366 11.5173 10.6971 11.8236 10.9797 11.9649L11.62 12.2851L10.6972 13.6695C10.5031 13.9606 10.5415 14.3483 10.7889 14.5957L11.8267 15.6336L9.25661 18.2037C9.88595 19.1538 9.78213 20.4463 8.94513 21.2833Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrokenBone);
export default __webpack_public_path__ + "static/media/broken-bone.f9d0f02dc0c818402653b1992e86931e.svg";
export { ForwardRef as ReactComponent };